// Session 6 follow-up (fix A): one consistent "we're working on it" banner for
// anything that waits on a background job: preview refresh, image upload,
// draft generation, revision, analysis. Spinner + message, and an optional
// done state.
export default function Working({ text, done = false, tone = 'info', children }) {
  return (
    <div className={`banner banner-${done ? 'ok' : tone} working`} role="status" aria-live="polite">
      {!done && <span className="spinner" aria-hidden="true" />}
      {done && <span className="working-check" aria-hidden="true">✓</span>}
      <span>{text}</span>
      {children}
    </div>
  );
}

export async function pollUntil(check, { every = 8000, timeout = 240000 } = {}) {
  // Resolve true as soon as check() is truthy, false on timeout. Never throws.
  const deadline = Date.now() + timeout;
  while (Date.now() < deadline) {
    try { if (await check()) return true; } catch { /* keep polling */ }
    await new Promise((r) => setTimeout(r, every));
  }
  return false;
}
